module.exports = __webpack_public_path__ + "img/visa.4f815262.png";